import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ErrorBoundary/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/containers/holdings/index.tsx")